import { render } from "./s-h3.vue?vue&type=template&id=70dc84f6"
import script from "./s-h3.vue?vue&type=script&lang=js"
export * from "./s-h3.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\paintcare\\pcsitelocator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__